import depositSchedule from "../Config/DepositSchedule";
import EAPs from "../Config/EAPs";
import planTypes from "../Config/PlanTypes";
import provincialTaxRates from "../Config/ProvincialTaxRates";
import RESP from "../Config/RESP";
import fees from "../Config/Fees";
import { PLAN_TYPES, planNameForPlanTypeIDUntranslated } from "./PlanUtils";
import DepositSchedule from "../Config/DepositSchedule";

//Returns a number value from the DepositSchedule configuration file
export const getDepositScheduleValue = (
    planName,
    depositMode,
    depositCode,
    key,
) => {
    try {
        return +depositSchedule[planName][depositMode][depositCode][key];
    } catch (e) {
        console.error(e);
    }
};

export const getDepositScheduleConfigValueForKeyWithState = (state, key) => {
    return getDepositScheduleValue(
        planNameForPlanTypeIDUntranslated(state.plan.planTypeID),
        state.plan.depositMode,
        state.plan.depositCode,
        key,
    );
};
export const getDepositModeConfigValueForKeyWithState = (state, key) => {
    console.log(state);
    if (
        state.plan.depositMode === "" ||
        state.plan.planTypeID === -1 ||
        state.plan.planTypeID === 100
    ) {
        return null;
    }
    return getDepositModeConfigValueForKey(
        planNameForPlanTypeIDUntranslated(state.plan.planTypeID),
        state.plan.depositMode,
        key,
    );
};

export const depositModeNameForPlan = (state) => {
    return DepositSchedule[
        planNameForPlanTypeIDUntranslated(state.plan.planTypeID)
    ][state.plan.depositMode].ModeName;
};

//Returns a number value from the EAPs configuration file
export const getEAPConfigValue = (state, key) => {
    return +EAPs[planNameForPlanTypeIDUntranslated(state.plan.planTypeID)][key];
};

//Returns a number value from the PlanTypes configuration file
export const getDepositModeConfigValueForKey = (planName, depositMode, key) => {
    console.log(
        "Getting deposit mode config value for key",
        planName,
        depositMode,
        key,
    );
    return +depositSchedule[planName][depositMode][key];
};

//Returns a string value from the DepositSchedule configuration file
export const getDepositModeStringConfigValueForKey = (
    planName,
    depositMode,
    key,
) => {
    return `${depositSchedule[planName][depositMode][key]}`;
};

//Returns a number value from the DepositSchedule configuration file
export const getDepositSchedulePlanConfigValueForKey = (planName, key) => {
    return +depositSchedule[planName][key];
};

//Returns a number value from the PlanTypes configuration file
export const getPlanTypesConfigValueForKey = (planName, key) => {
    return +planTypes[planName][key];
};

//Returns a number value from the ProvincialTaxRates configuration file
export const getProvincialTaxRateConfigForKey = (province, key) => {
    return +(provincialTaxRates[key][province] || 0);
};

//Returns all of the deposit modes for a given plan type
export const getDepositModesForPlanType = (planName) => {
    return Object.keys(depositSchedule[planName]);
};

//Returns a number value from the RESP configuration file
export const getNumberValueFromRESPConfig = (key) => {
    return +RESP[key];
};

export const getAdminFeeRateForPlanType = (planTypeID) => {
    return +fees[planNameForPlanTypeIDUntranslated(planTypeID)]["AdminFee"];
};
export const getDepositoryFee = (state) => {
    return +fees[planNameForPlanTypeIDUntranslated(state.plan.planTypeID)][
        "DepositoryFee"
    ][state.plan.depositMode];
};

export const getEnrolmentFee = (state) => {
    return +fees[planNameForPlanTypeIDUntranslated(state.plan.planTypeID)][
        "EnrolmentFee"
    ];
};

export const getInterestRateForProjections = () => {
    return getNumberValueFromRESPConfig("InterestRateForProjections");
};

//Get the interest rate to use for projections
export const interestRateForProjections = () => {
    return getNumberValueFromRESPConfig("InterestRateForProjections");
};

export const discretionarySalesChargeReturnRate = (state) => {
    return getPlanTypesConfigValueForKey(
        planNameForPlanTypeIDUntranslated(state.plan.planTypeID),
        "DiscretionarySalesChargeReturnRate",
    );
};
